// The permission catalogue, shared by the RBAC editor and the Role Permissions
// summary in Settings.
//
// The summary used to be a hardcoded table of ticks. It described the roles as they
// were seeded and never changed again, so once anyone edited a role in RBAC the two
// disagreed — the table went on saying "Switch Units: Super Admin only" after that
// permission had been granted to Unit Admin. Both views now read the same labels and
// the same live role data, so they cannot drift apart.

export const PERMISSION_GROUPS = {
  "Navigation": ["switchUnits"],
  "Settings": ["manageUsers", "manageRoles", "accessSettings"],
  "Machines": ["editMachines", "addMachines", "deleteMachines", "transferMachines"],
  "PM Plan": ["editPM", "clearPMCell", "editPMPlanRow", "deletePMPlanRow"],
  "History": ["addHistory", "editHistory", "deleteHistory"],
  "Spares": ["editSpares", "useSpares", "deleteSpares"],
  "View": ["viewAll"],
  "Checksheets": ["fillChecksheet", "approveChecksheet", "editChecksheetTemplate", "downloadChecksheetAudit", "managePMCheckSheetTemplate"],
  "Reports": ["accessReports"],
  "Integrations": ["manageApiKeys"],
};

export const PERMISSION_LABELS = {
  switchUnits: "Switch between units",
  manageUsers: "Manage users (add/edit/delete)",
  manageRoles: "Manage roles & permissions (RBAC)",
  accessSettings: "Access Settings page",
  editMachines: "Edit existing machines",
  addMachines: "Add new machines",
  deleteMachines: "Delete a machine (removes its PM plan rows too)",
  transferMachines: "Transfer a machine to another unit",
  editPM: "Edit PM Plan / mark PM completion",
  editPMPlanRow: "Edit a PM Plan row (description, location, frequency, months)",
  deletePMPlanRow: "Delete a PM Plan row",
  addHistory: "Add maintenance history entries",
  editHistory: "Edit maintenance history",
  deleteHistory: "Delete history entries",
  editSpares: "Edit spare parts",
  viewAll: "View all data (read-only)",
  fillChecksheet: "Fill checksheet executions",
  approveChecksheet: "Approve checksheet executions",
  editChecksheetTemplate: "Edit checksheet templates",
  downloadChecksheetAudit: "Download checksheet audit reports",
  managePMCheckSheetTemplate: "Manage PM check sheet templates",
  accessReports: "Access Reports section",
  deleteSpares: "Delete spare parts (more restrictive)",
  useSpares: "Record spare part usage / restock",
  clearPMCell: "Clear PM cell (wipe completion data)",
  manageApiKeys: "Manage external API keys (Administration -> API Keys)",
};

// Permission keys in display order, grouped. Any key a role holds that is not listed
// above still appears, so a newly added permission is never silently invisible.
export function orderedPermissions(extraKeys = []) {
  const known = Object.values(PERMISSION_GROUPS).flat();
  const rows = [];
  for (const [group, keys] of Object.entries(PERMISSION_GROUPS)) {
    for (const k of keys) rows.push({ group, key: k, label: PERMISSION_LABELS[k] || k });
  }
  for (const k of extraKeys) {
    if (!known.includes(k)) rows.push({ group: "Other", key: k, label: PERMISSION_LABELS[k] || k });
  }
  return rows;
}
